var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBound(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9065 19.9999H5.86646C3.4398 19.9999 1.89313 17.3999 3.06646 15.2666L6.17313 9.61325L9.0798 4.31992C10.2931 2.11992 13.4665 2.11992 14.6798 4.31992L17.5998 9.61325L18.9998 12.1599L20.7065 15.2666C21.8798 17.3999 20.3331 19.9999 17.9065 19.9999Z",
    fill: "#2A2B28"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2003 21.3329C30.2003 26.1196 26.3203 29.9996 21.5337 29.9996C17.467 29.9996 14.067 27.2129 13.1203 23.4263C13.027 23.0263 13.3337 22.6663 13.747 22.6663H18.7737C20.627 22.6663 22.307 21.7063 23.2537 20.1196C24.187 18.5196 24.227 16.5996 23.3203 14.9729L22.6537 13.7463C22.4003 13.2929 22.7603 12.7463 23.267 12.8396C27.2137 13.6396 30.2003 17.1329 30.2003 21.3329Z",
    fill: "#2A2B28"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBound);
export default __webpack_public_path__ + "static/media/bound.026e234f862b06ae8d49ea219d253798.svg";
export { ForwardRef as ReactComponent };